import { render, staticRenderFns } from "./TheoryList.vue?vue&type=template&id=6c9354f9&"
import script from "./TheoryList.vue?vue&type=script&lang=ts&"
export * from "./TheoryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports